import { useMemo } from 'react';
import { getPersonalMenusList } from '../../config.data';
import { GlobalTracker } from '@/utils/Tracker';
import styles from './index.module.less';
import MobxWrap from '@/components/MobxWrap';

/**
 * 用户个人中心列表，内部列表不参与SSR渲染
 * @param {*} props mobxStore
 */
const UserMenuList = MobxWrap(['auth', 'reseller', 'area'], (props) => {
  const { auth, reseller, area } = props;

  const personalData = useMemo(() => {
    return getPersonalMenusList({ area, auth, reseller });
  }, [auth.isLoggedIn, auth.logout, reseller.isIndividualReseller]);

  const onClick = (item) => {
    GlobalTracker.navigation({
      action: 'menu_personal_item_click',
      eventLabel: item.name,
    });
    if (item.type === 'link') {
      window.location.href = item.url;
    } else if (item.type === 'hyperlink') {
      window.location.href = item.url;
    } else if (item.type === 'button') {
      item.onClick();
    }
  };

  return (
    <div
      className={styles.popup}
      onMouseEnter={() => {
        GlobalTracker.navigation({ action: 'personal_center_show' });
      }}
    >
      <div className={styles.wrap}>
        <ul className={styles.container}>
          {personalData.map((o, k) => (
            <li key={k}>
              <button onClick={() => onClick(o)}>
                {!o?.disabledIcon && <img className={styles.ic} src={o.icon} alt='' />}
                {o.title}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
});

export default UserMenuList;
